// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"c1aa28143fc65ed67001","655":"b624315191ff7ee73d45"}[chunkId] + ".js";
};